import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
